import prefix from './Prefix';
export default prefix;
